'use strict';

class ReportFormVisma {
  constructor($filter, commonService, reportService, Notification) {
    this.$filter = $filter;
    this.commonService = commonService;
    this.reportService = reportService;
    this.Notification = Notification;
  }

  $onInit() {
    this.results = {};
    this.params = {
      name: this.$filter('capitalize')(moment().subtract(1, 'month').startOf('month').format('MMMM YYYY')),
      from: moment().subtract(1, 'month').startOf('month').format('DD.MM.YY'),
      to: moment().subtract(1, 'month').endOf('month').format('DD.MM.YY')
    };

    this.commonService.datePicker({
      field: $('#from')[0]
    });

    this.commonService.datePicker({
      field: $('#to')[0]
    });

    this.load();
  }

  load() {
    this.reportService.getBatches()
      .then((resp) => {
        this.results = resp.data;
      });
  }

  undatefy(clone) {
    this.params.from = moment(clone.from, 'YYYY-MM-DD').format('DD.MM.YY');
    this.params.to = moment(clone.to, 'YYYY-MM-DD').format('DD.MM.YY');
  }

  export() {
    $('button.submit').prop('disabled', true);

    let clone = angular.copy(this.params);
    // let number;

    this.params.from = moment(clone.from, 'DD.MM.YY').format('YYYY-MM-DD');
    this.params.to = moment(clone.to, 'DD.MM.YY').format('YYYY-MM-DD');

    this.reportService.createBatch(this.params)
      .then(() => {
        $('button.submit').prop('disabled', false);

        this.undatefy(this.params);
        this.load();
      })
      .catch(() => {
        $('button.submit').prop('disabled', false);

        this.undatefy(clone);
        this.Notification.info('Det var ingen bilag i valgt periode.');
      });
  }

  download(number) {
    this.reportService.downloadBatch(number);
  }
}

ReportFormVisma.$inject = ['$filter', 'commonService', 'reportService', 'Notification'];

const reportFormVisma = {
  controller: ReportFormVisma,
  template: `
    <h2>Vismaeksport</h2>

    <h3 class="subheader">Eksporter ny bilagsbunt</h3>

    <fieldset>
      <div>
        <label for="name">Navn</label>
        <input type="text" name="name" ng-model="$ctrl.params.name" required>
      </div>

      <div class="row">
        <div class="large-6 columns">
          <input type="text" id="from" ng-model="$ctrl.params.from" placeholder="dd.mm.åå" required date-formatter>
        </div>
        <div class="large-6 columns">
          <input type="text" id="to" ng-model="$ctrl.params.to" placeholder="dd.mm.åå" required date-formatter>
        </div>
      </div>

      <button class="button submit" ng-click="$ctrl.export()">Eksporter</button>
    </fieldset>

    <div ng-if="$ctrl.results.length">
      <h3 class="subheader">Tidligere bunter</h3>

      <table class="responsive">
        <thead>
          <tr>
            <th>Navn</th>
            <th>Eksportdato</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="item in $ctrl.results track by $index">
            <td>{{ item.name }}</td>
            <td>{{ item.created | dateFormat:true }}</td>
            <td class="right-align"><a href ng-click="$ctrl.download(item.number)" class="button secondary"><i class="fa fa-file-code-o"></i> Eksporter</a></td>
          </tr>
        </tbody>
      </table>
    </div>
  `
};

angular
  .module('SendRegning')
  .component('reportFormVisma', reportFormVisma)
  .config(($routeProvider) => {
    $routeProvider
      .when('/rapport/visma', {
        title: 'Vismaeksport',
        template: '<report-form-visma />',
        secure: true
      });
  });
